<template>
  <div class="publicMain">
    <!-- 角色编码、角色名称筛选框 -->
    <el-row class="leftClass">
      <el-col :span="6">
        <label class="labelClass">{{ $t("jsgl.formRoleId") }}</label>
        <el-input
          v-model="queryForm.jsid"
          style="width: 60%;"
          size="small"
        ></el-input>
      </el-col>
      <el-col :span="6">
        <label class="labelClass">{{ $t("jsgl.formRoleName") }}</label>
        <el-input
          v-model="queryForm.jsname"
          style="width: 60%;"
          size="small"
        ></el-input>
      </el-col>
    </el-row>
    <!-- 新增、查找、重置按钮 -->
    <el-row class="rightClass">
      <el-col :span="12" style="text-align: left;">
        <el-button type="primary" size="small" @click="openDialog('add')">{{
          $t("common.addedBtn")
        }}</el-button>
      </el-col>
      <el-col :span="12">
        <el-button type="primary" size="small" @click="selectJs">{{
          $t("common.searchBtn")
        }}</el-button>
        <el-button size="small" @click="resetSearch('reset')">{{
          $t("common.resetBtn")
        }}</el-button>
      </el-col>
    </el-row>
    <el-row>
      <el-table
        v-loading="tabLoading"
        :element-loading-text="$t('elTable.loadingText')"
        element-loading-spinner="el-icon-loading"
        :data="tableData"
        border
        style="width: 100%;"
        :header-cell-style="$store.state.headerCellStyle"
        :cell-style="$store.state.cellStyle"
      >
        <el-table-column
          :label="$t('common.number')"
          width="80px"
          prop="rn"
          header-align="center"
          align="center"
        ></el-table-column>
        <el-table-column
          :label="$t('jsgl.formRoleId')"
          prop="jsid"
          header-align="center"
          align="center"
        ></el-table-column>
        <el-table-column
          :label="$t('jsgl.formRoleName')"
          prop="jsname"
          header-align="center"
          align="center"
        ></el-table-column>
        <el-table-column
          :label="$t('jsgl.usercount')"
          prop="usercount"
          header-align="center"
          align="center"
        >
          <template slot-scope="scope">
            <div
              style="cursor: pointer;color: #409EFF"
              @click="openDialog('editUserJs', scope.row)"
            >
              {{ scope.row.usercount }}
            </div>
          </template>
        </el-table-column>
        <el-table-column
          :label="$t('common.operation')"
          width="180px"
          header-align="center"
          align="center"
        >
          <template slot-scope="scope">
            <el-button type="text" @click="openDialog('edit', scope.row)">{{
              $t("common.editBtn")
            }}</el-button>
            <el-button type="text" @click="openDialog('set', scope.row)">{{
              $t("jsgl.permiSetBtn")
            }}</el-button>
            <el-button type="text" @click="openDialog('del', scope.row)">{{
              $t("common.deleteBtn")
            }}</el-button>
          </template>
        </el-table-column>
      </el-table>
    </el-row>

    <!--角色信息模态框-->
    <el-dialog
      :title="dialogTitle"
      :visible.sync="dialogFormVisible"
      :close-on-click-modal="false"
      :close-on-press-escape="true"
      @close="handleClose('form')"
    >
      <label slot="title">
        <i :class="dialogTitleIcon" style="font-size: 16px; font-weight: bold;">
          <span style="margin-right: 5px;">
            {{ this.dialogTitle }}
          </span>
        </i>
      </label>
      <el-card style="padding: 0 20% 0 20%">
        <el-form
          :model="ruleForm"
          :rules="rules"
          ref="ruleForm"
          label-width="120px"
          :validate-on-rule-change="false"
          size="small"
        >
          <el-form-item :label="$t('jsgl.formRoleId')" prop="jsid">
            <el-input
              :disabled="disabledFlg"
              v-model="ruleForm.jsid"
            ></el-input>
          </el-form-item>
          <el-form-item :label="$t('jsgl.formRoleName')" prop="jsname">
            <el-input v-model="ruleForm.jsname"></el-input>
          </el-form-item>
        </el-form>
      </el-card>
      <div slot="footer" class="dialog-footer">
        <el-button size="small" @click="dialogFormVisible = false">{{
          $t("common.cancelBtn")
        }}</el-button>
        <el-button
          type="primary"
          size="small"
          @click="submitForm('ruleForm')"
          >{{ $t("common.saveBtn") }}</el-button
        >
      </div>
    </el-dialog>

    <!--权限配置树-->
    <el-dialog
      :title="treeDialogTitle"
      :visible.sync="dialogFormTreeVisible"
      :close-on-click-modal="false"
      :close-on-press-escape="true"
      @close="handleClose('tree')"
    >
      <label slot="title">
        <i
          :class="dialogTitleTreeIcon"
          style="font-size: 16px; font-weight: bold;"
        >
          <span style="margin-right: 5px;">
            {{ this.treeDialogTitle }}
          </span>
        </i>
      </label>
      <el-row>
        <el-card style="padding: 0 10%" :body-style="treeStyle">
          <el-tree
            :data="treeData"
            :props="treeDefaultProps"
            :expand-on-click-node="false"
            :accordion="true"
            show-checkbox
            ref="permissionTree"
            node-key="qid"
            :highlight-current="true"
            :default-expand-all="false"
            :default-expanded-keys="['0']"
            :default-checked-keys="checkKey"
          >
          </el-tree>
        </el-card>
      </el-row>
      <div slot="footer" class="dialog-footer">
        <el-button size="small" @click="dialogFormTreeVisible = false">{{
          $t("common.cancelBtn")
        }}</el-button>
        <el-button type="primary" size="small" @click="saveQx">{{
          $t("common.saveBtn")
        }}</el-button>
      </div>
    </el-dialog>

    <!--    用户模态框-->
    <el-dialog
      :title="yonghudialogTitle"
      width="50%"
      :visible.sync="userdialogVisible"
      @close="handleClose('userjsedit')"
    >
      <el-row class="rightClass">
        <el-col :span="12" style="text-align: left;">
          <el-button
            type="primary"
            size="small"
            @click="openDialog('editUserJs2')"
            >{{ $t("jsgl.bianji") }}</el-button
          >
        </el-col>
      </el-row>
      <el-row>
        <el-table
          ref="multipleTable"
          :data="usertableData"
          border
          style="width: 100%; font-size: 12px;"
          v-loading="usertabLoading"
          :element-loading-text="$t('elTable.loadingText')"
          :header-cell-style="$store.state.headerCellStyle"
          :cell-style="$store.state.cellStyle"
          @selection-change="handleSelectionChange"
        >
          <el-table-column
            type="selection"
            width="55"
            header-align="center"
            align="center"
          ></el-table-column>
          <el-table-column
            prop="yhmc"
            :label="$t('yhgl.queryFormName')"
            header-align="center"
            align="center"
          ></el-table-column>
          <el-table-column
            prop="yhbh"
            :label="$t('yhgl.queryFormLoginName')"
            header-align="center"
            align="center"
          ></el-table-column>
          <el-table-column
            prop="jsname"
            :label="$t('yhgl.tableColRole')"
            header-align="center"
            align="center"
          ></el-table-column>
        </el-table>
      </el-row>
      <!-- 分页组件 -->
      <el-row>
        <Pagination
          :currentPage="currentPage"
          :total="total"
          :limit="limit"
          :small="true"
          :pageSizes="$store.state.pageSizes"
          @handleCurrentChange="handleCurrentChange"
          @handleSizeChange="handleSizeChange"
        />
      </el-row>
      <div slot="footer" class="dialog-footer">
        <el-button size="small" @click="userdialogVisible = false">{{
          $t("common.cancelBtn")
        }}</el-button>
        <el-button type="primary" size="small" @click="delUserjs">{{
          $t("jsgl.shanchu")
        }}</el-button>
      </div>
    </el-dialog>

    <!--    用户模态框2.0-->
    <el-dialog
      width="50%"
      :visible.sync="userdialogVisible2"
      @close="handleClose('userjsedit2')"
    >
      <el-row class="leftClass">
        <el-col :span="8">
          <label style="width: 100px;">{{ $t("jsgl.NameOrNumber") }}：</label>
          <el-input
            v-model="userqueryForm2.yhbh"
            clearable
            size="small"
            style="width: 60%;"
            placeholder="请输入名字或账号"
          ></el-input>
        </el-col>
      </el-row>
      <el-row class="rightClass">
        <el-col :span="24">
          <el-button size="small" type="primary" @click="searchUser('query')">{{
            $t("yhgl.queryBtn")
          }}</el-button>
          <el-button size="small" @click="userresetSearch('reset')">{{
            $t("yhgl.resetBtn")
          }}</el-button>
        </el-col>
      </el-row>
      <el-row>
        <el-table
          ref="multipleTable2"
          :data="usertableData2"
          border
          style="width: 100%; font-size: 12px;overflow-y: auto;max-height: 400px"
          v-loading="usertabLoading2"
          :element-loading-text="$t('elTable.loadingText')"
          :header-cell-style="$store.state.headerCellStyle"
          :cell-style="$store.state.cellStyle"
          @selection-change="handleSelectionChange"
        >
          <el-table-column
            type="selection"
            width="55"
            header-align="center"
            align="center"
          ></el-table-column>
          <el-table-column
            prop="yhmc"
            :label="$t('yhgl.queryFormName')"
            header-align="center"
            align="center"
          ></el-table-column>
          <el-table-column
            prop="yhbh"
            :label="$t('yhgl.queryFormLoginName')"
            header-align="center"
            align="center"
          ></el-table-column>
          <el-table-column
            prop="jsname"
            :label="$t('yhgl.tableColRole')"
            header-align="center"
            align="center"
          ></el-table-column>
        </el-table>
      </el-row>
      <div slot="footer" class="dialog-footer">
        <el-button size="small" @click="userdialogVisible2 = false">{{
          $t("common.cancelBtn")
        }}</el-button>
        <el-button type="primary" size="small" @click="editUserJs">{{
          $t("common.saveBtn")
        }}</el-button>
      </div>
    </el-dialog>
  </div>
</template>

<script>
import * as qxgl from "@/api/qxgl";
export default {
  name: "jsgl",
  computed: {
    rules() {
      // 模态框数据校验规则
      return {
        jsid: [
          {
            required: true,
            message: this.$t("jsgl.ruleBlurMsg") + this.$t("jsgl.formRoleId"),
            trigger: "blur",
          },
        ],
        jsname: [
          {
            required: true,
            message: this.$t("jsgl.ruleBlurMsg") + this.$t("jsgl.formRoleName"),
            trigger: "blur",
          },
        ],
      };
    },
    treeDefaultProps() {
      // 默认权限数据节点绑定数据
      return {
        // label: this.$i18n.locale == 'zh' ? 'titleZh' : 'titleEn',
        label: "qname",
        children: "children",
      };
    },
    treeStyle() {
      return {
        // 'height': this.screenHeight - 540 + 'px',
        height: 400 + "px",
        "overflow-y": "auto",
        // 'min-height': '200px',
      };
    },
    tabHeight() {
      return this.screenHeight - 255;
    },
  },
  data() {
    return {
      queryForm: {
        jsid: "",
        jsname: "",
      },
      userqueryForm: {
        yhmc: "",
        yhbh: "",
        jsid: "",
      },
      userqueryForm2: {
        yhmc: "",
        yhbh: "",
        jsid: "",
      },
      usertableData: [],
      usertableData2: [],
      tableData: [],
      treeData: [],
      multiple: {
        jsid: "",
        multipleSelection: [],
      },
      dialogFormVisible: false,
      dialogFormTreeVisible: false,
      userdialogVisible: false,
      userdialogVisible2: false,
      yonghudialogTitle: "", // 角色模态框标题
      dialogTitle: "", // 角色模态框标题
      treeDialogTitle: "", // 角色权限模态框标题
      dialogTitleIcon: "", // 角色模态框标题图标
      dialogTitleTreeIcon: "", // 角色权限模态框标题图标
      ruleForm: {
        jsid: "",
        jsname: "",
      },
      disabledFlg: false, // 输入框是否可编辑
      tabLoading: true, // 表格请求数据loading层
      usertabLoading: true, // 表格请求数据loading层
      usertabLoading2: true, // 表格请求数据loading层
      saveFlg: "", // 保存操作区分
      checkKey: [],
      selectedKeyArr: [], // 权限树选中节点数组
      updateQxJsid: "",
      screenHeight: "",
      currentPage: 1, // 页码
      limit: this.$store.state.dataDisplayNum, // 分页显示条数
      total: 0, // 列表数据量
      pageSizes: this.$store.state.pageSizes, // 分页显示可选择条数
      jsid: "", // 用户模态框jsid
      // disabledFlgbj: false,
      // disabledFlgsc: true
    };
  },
  methods: {
    // 用户角色绑定
    editUserJs() {
      if (this.multiple.multipleSelection.length <= 0) {
        this.$message.error(this.$t("common.zwxzsj"));
        return;
      }
      this.$ajax
        .post("/api/editUserJs", this.multiple)
        .then((res) => {
          this.userdialogVisible2 = false;
          if (res.data.code == "200") {
            this.searchUser("js");
            this.selectJs();
            this.$message.success(this.$t("common.bdSuccess"));
          }
        })
        .catch((error) => {
          this.userdialogVisible2 = false;
        });
    },
    // 用户角色解除绑定
    delUserjs() {
      if (this.multiple.multipleSelection.length <= 0) {
        this.$message.error(this.$t("common.zwxzsj"));
        return;
      }
      this.$ajax
        .post("/api/delUserjs", this.multiple)
        .then((res) => {
          this.userdialogVisible = false;
          if (res.data.code == "200") {
            this.selectJs();
            this.$message.success(this.$t("common.jbSuccess"));
          }
        })
        .catch((error) => {
          this.userdialogVisible = false;
        });
    },

    handleSelectionChange(val) {
      this.multiple.multipleSelection = val;
      console.log(this.multiple.multipleSelection);
    },

    //重置操作
    resetSearch() {
      this.queryForm.jsid = "";
      this.queryForm.jsname = "";
      this.selectJs();
    },
    handleClose(flg) {
      if (flg == "form") {
        this.$refs["ruleForm"].resetFields();
      } else if (flg == "tree") {
      } else if (flg == "userjsedit") {
        // this.userqueryForm.yhmc = "";
        // this.userqueryForm.yhbh = "";
        this.userqueryForm.jsid = "";
        this.search = "";
        // this.disabledFlgbj = false;
        // this.disabledFlgsc = true;
      } else if (flg == "userjsedit2") {
        // this.userqueryForm2.yhmc = "";
        this.userqueryForm2.yhbh = "";
        this.userqueryForm2.jsid = "";
      }
    },
    /** 打开模态框 */
    openDialog(flg, row) {
      if (flg == "add") {
        this.dialogFormVisible = true;
        this.$nextTick(() => {
          this.dialogTitle = this.$t("jsgl.addDiaTitle");
          this.dialogTitleIcon = "el-icon-document-add";
          this.disabledFlg = false;
        });
      } else if (flg == "edit") {
        this.dialogFormVisible = true;
        this.$nextTick(() => {
          this.dialogTitle = this.$t("jsgl.editDiaTitle");
          this.dialogTitleIcon = "el-icon-edit-outline";
          this.ruleForm.jsid = row.jsid;
          this.ruleForm.jsname = row.jsname;
          this.disabledFlg = true;
        });
      } else if (flg == "set") {
        this.dialogFormTreeVisible = true;
        this.$nextTick(() => {
          this.updateQxJsid = "";
          this.dialogTitleTreeIcon = "el-icon-s-tools";
          this.treeDialogTitle = this.$t("jsgl.dialogRoleSet");
          this.selectQx();
          this.selectUserQx(row.jsid);
          this.updateQxJsid = row.jsid;
        });
      } else if (flg == "editUserJs") {
        this.userdialogVisible = true;
        this.$nextTick(() => {
          this.yonghudialogTitle = "当前编辑：" + row.jsname + "";
          this.jsid = row.jsid;
          this.multiple.jsid = row.jsid;
          this.searchUser("js");
          // this.searchUser("query");
        });
      } else if (flg == "editUserJs2") {
        this.userdialogVisible2 = true;
        this.$nextTick(() => {
          this.usertabLoading2 = false;
          this.usertableData2 = [];
        });
      } else if (flg == "del") {
        this.$confirm(this.$t("jsgl.scxtje"), this.$t("common.tips"), {
          distinguishCancelAndClose: true,
          confirmButtonText: this.$t("common.confirmBtn"),
          cancelButtonText: this.$t("common.cancelBtn"),
        })
          .then((tem) => {
            qxgl.deleteRole(row).then((res) => {
              if (res.data.code == "200") {
                this.$message.success(res.data.data);
                this.selectJs();
              }
            });
          })
          .catch((err) => {});
      }
      this.saveFlg = flg;
    },
    /** 查询用户 */
    searchUser(typeFlg) {
      let _this = this;
      if (typeFlg != "query") {
        _this.usertableData = [];
        // if (typeFlg == "reset" || typeFlg == "query") {
        if (typeFlg == "reset") {
          _this.userqueryForm.currentPage = 1;
          _this.userqueryForm.limit = _this.$store.state.dataDisplayNum;
          _this.currentPage = 1;
        } else if (typeFlg == "js") {
          // this.disabledFlgbj = true;
          // this.disabledFlgsc = false;
          _this.userqueryForm.currentPage = 1;
          _this.userqueryForm.limit = _this.$store.state.dataDisplayNum;
          _this.currentPage = 1;
          this.userqueryForm.jsid = this.jsid;
        } else {
          _this.userqueryForm.currentPage = _this.currentPage;
          _this.userqueryForm.limit = _this.limit;
        }
        _this.usertabLoading = true; // 关闭请求时的loading层
        _this.$ajax
          .post("/api/selectyxzry", _this.userqueryForm)
          .then((res) => {
            _this.usertabLoading = false; // 关闭请求时的loading层
            if (res.data.code == "200") {
              if (res.data.data.length > 0) {
                _this.total = res.data.data[0].tableCount;
              } else {
                _this.total = 0;
              }
              _this.usertableData = res.data.data;
            }
          })
          .catch((error) => {
            _this.usertabLoading = false; // 关闭请求时的loading层
          });
      } else {
        if (_this.userqueryForm2.yhbh == "") {
          this.usertableData2 = [];
          _this.$message.error(this.$t("common.qsrcxtj"));
          return;
        }
        _this.usertabLoading2 = true; // 关闭请求时的loading层
        this.userqueryForm2.jsid = this.jsid;
        _this.$ajax
          .post("/api/selectyxzry2", _this.userqueryForm2)
          .then((res) => {
            _this.usertabLoading2 = false; // 关闭请求时的loading层
            if (res.data.code == "200") {
              _this.usertableData2 = res.data.data;
            }
          })
          .catch((error) => {
            _this.usertabLoading2 = false; // 关闭请求时的loading层
          });
      }
    },
    /** 重置操作 */
    userresetSearch(typeFlg) {
      this.usertableData2 = [];
      // this.userqueryForm2.yhmc = "";
      this.userqueryForm2.yhbh = "";
      // this.userqueryForm.jsid = "";
      // this.disabledFlgbj = false;
      // this.disabledFlgsc = true;
      // this.searchUser(typeFlg);
    },
    /** 页码改变时会触发 */
    handleCurrentChange(uniqueNum, val) {
      this.currentPage = val;
      this.searchUser();
    },
    /** 每页条数改变时触发 */
    handleSizeChange(uniqueNum, val) {
      this.limit = val;
      this.currentPage = 1;
      this.searchUser();
    },

    /** 查询所有角色 */
    selectJs() {
      let _this = this;
      _this.$ajax
        .post("/api/selectJs", _this.queryForm)
        .then((res) => {
          _this.tabLoading = false;
          if (res.data.code == "200") {
            _this.tableData = res.data.data;
          }
        })
        .catch((error) => {
          _this.tabLoading = false; // 关闭请求时的loading层
        });
    },
    /** 保存模态框数据 */
    submitForm(formName) {
      this.$refs[formName].validate((valid) => {
        if (valid) {
          if (this.saveFlg === "add") {
            this.addJs();
          } else if (this.saveFlg === "edit") {
            this.editJs();
          }
        } else {
          console.log("error submit!!");
          return false;
        }
      });
    },
    /** 添加角色 */
    addJs() {
      let _this = this;
      _this.$ajax
        .post("/api/addJs", _this.ruleForm)
        .then((res) => {
          _this.dialogFormVisible = false;
          if (res.data.code == "200") {
            _this.selectJs();
            _this.$message.success(_this.$t("common.addSuccess"));
          }
        })
        .catch((error) => {
          _this.dialogFormVisible = false;
        });
    },
    /** 编辑角色 */
    editJs() {
      let _this = this;
      _this.$ajax
        .post("/api/updateJs", _this.ruleForm)
        .then((res) => {
          _this.dialogFormVisible = false;
          if (res.data.code == "200") {
            _this.selectJs();
            _this.$message.success(_this.$t("common.editSuccess"));
          }
        })
        .catch((error) => {
          _this.dialogFormVisible = false;
        });
    },
    /** 查询权限 */
    selectQx() {
      this.$ajax.post("/api/getQxByQid").then((res) => {
        let a = this.$comUtils.getListData(
          res.data.data,
          "0",
          {
            children: "children",
            label: "qname",
            id: "qid",
            pid: "pid",
          },
          "array"
        );
        a[0].label = this.$t("common.all");
        a[0].qname = this.$t("common.all");
        a[0].qid = "0";
        this.treeData = a;
      });
    },
    /** 查询角色权限 */
    selectUserQx(jsid) {
      let _this = this;
      _this.checkKey = [];

      _this.$ajax
        .post("/api/selectUserQx", _this.$qs.stringify({ jsid: jsid }))
        .then((res) => {
          if (res.data.code == "200") {
            _this.checkKey = res.data.data;
          }
        });
    },
    saveQx() {
      let _this = this;
      let keyArr = _this.$refs.permissionTree
        .getCheckedKeys()
        .concat(_this.$refs.permissionTree.getHalfCheckedKeys());
      _this.$ajax
        .post(
          "/api/updateUserQx",
          _this.$qs.stringify({
            keyArr: keyArr.toString(),
            jsid: _this.updateQxJsid,
          })
        )
        .then((res) => {
          _this.dialogFormTreeVisible = false;
          if (res.data.code == "200") {
            _this.$message.success(_this.$t("jsgl.permiSetOk"));
          }
        })
        .catch((error) => {
          _this.dialogFormTreeVisible = false;
        });
    },
  },
  mounted() {
    this.selectJs();
    // 监听浏览器的宽和高
    this.screenHeight = document.body.clientHeight;
    window.addEventListener(
      "resize",
      () => (this.screenHeight = window.innerHeight),
      false
    );
  },
};
</script>

<style lang="scss" scoped>
.rightClass {
  margin: 10px 0;
}
.labelClass {
  width: 100px;
  margin-right: 10px;
}
::v-deep .el-dialog__body {
  // height: 354px;
  max-height: 800px;
  overflow-x: auto;
}
</style>
